import { GoatAwkward, useIntl, useSettings } from '@capsicum/common';
import { GenericDrawer } from '@capsicum/common-web';

export type NCRegistrationErrorDrawerProps = {
	closeModal: () => void;
	testID: string;
};

export const NCRegistrationErrorDrawer = ({ closeModal, testID }: NCRegistrationErrorDrawerProps) => {
	const { $t } = useIntl();
	const { settings } = useSettings();

	const ncRegistrationErrorDrawerData = {
		buttonText: $t('ncOnboarding.registration.errorButton'),
		description: $t('ncOnboarding.registration.errorDesc'),
		image: GoatAwkward,
		isButtonFullWidth: true,
		isButtonOnRow: false,
		onSecondaryActionOnButtonPress: () => {
			closeModal();
			window.open(settings?.contactUsHereLink as string);
		},
		secondaryActionButtonText: $t('ncOnboarding.notSupported.contactSupportButton'),
		testID: testID,
		title: $t('ncOnboarding.registration.errorTitle')
	};

	return <GenericDrawer {...ncRegistrationErrorDrawerData} onButtonPress={closeModal}></GenericDrawer>;
};
